import React from "react";
import { FormattedMessage } from "react-intl";

import Icon from "../../../../../icon";
import { SubmitButton } from "../../common-style";

import {
    StyledMessageDisplay,
    Check,
    Times,
    NextTaskWrapper,
} from "./styles";
import messages from "./messages";
import { IProps } from "./interfaces";

const MessageDisplay = ({ type, isLow, handleHomeworkNext, isChristmas = false }: IProps) => (
    <StyledMessageDisplay isLow={isLow} type={type} isChristmas={isChristmas}>
        {type === "completed" && (
            <span style={{ position: "relative"}}>
                <Check>
                    <Icon i="check" />
                </Check>
                <FormattedMessage {...messages.correct} />
                {handleHomeworkNext && (
                    <NextTaskWrapper>
                        <SubmitButton onClick={handleHomeworkNext}>
                            <FormattedMessage {...messages.next} />
                        </SubmitButton>
                    </NextTaskWrapper>
                )}
            </span>
        )}
        {type === "incorrect" && (
            <span>
                <Times>
                    <Icon i="times" />
                </Times>
                <FormattedMessage {...messages.incorrect} />
            </span>
        )}
        {type === "timeup" && (
            <span>
                <Times>
                    <Icon i="times" />
                </Times>
                <FormattedMessage {...messages.timeup} />
            </span>
        )}
        {type === "slow" && (
            <span>
                <Times>
                    <Icon i="times" />
                </Times>
                <FormattedMessage {...messages.slow} />
            </span>
        )}
        {type === "fast" && (
            <span>
                <Times>
                    <Icon i="times" />
                </Times>
                <FormattedMessage {...messages.fast} />
            </span>
        )}
        {type === "incorrectNote" && (
            <span>
                <Times>
                    <Icon i="times" />
                </Times>
                <FormattedMessage {...messages.incorrectNote} />
            </span>
        )}
        {type === "editor" && (
            <span>
                <FormattedMessage {...messages.willBeDisplayed} />
            </span>
        )}
    </StyledMessageDisplay>
);

export default MessageDisplay;
